<template>
  <div>
    <sign-up-flow-selection
      v-if="noSignUpFlowSelected"
      :pass-and-pay="passAndPay"
      :user-can-invoice="userCanInvoice"
      @update-sign-up-flow="updateSignUpFlowType"
    />
    <div v-else>
      <multi-user-sign-up
        v-if="signUpFlowType === 'multi-user'"
        :current-user-information="currentUserInformation"
        :phone-number-regex="phoneNumberRegex"
        :course-title="courseTitle"
        :course-price="coursePrice"
        :course-id="courseId"
        :is-partner-course="isPartnerCourse"
        :partner-id="partnerId"
        :stripe-api-key="stripeApiKey"
        :stripe-account-id="stripeAccountId"
      />
    </div>
  </div>
</template>

<script>
import SignUpFlowSelection from './SignUpFlowSelection.vue';
import MultiUserSignUp from './MultiUserSignUp.vue';

export default {
  components: { SignUpFlowSelection, MultiUserSignUp },

  props: {
    selfSignUpLink: { type: String, required: true },
    currentUserInformation: { type: String, required: true },
    phoneNumberRegex: { type: String, required: true },
    courseTitle: { type: String, required: true },
    coursePrice: { type: Number, required: true },
    courseId: { type: Number, required: true },
    isPartnerCourse: { type: Boolean, required: true },
    partnerId: { type: Number, required: false, default: null },
    passAndPay: { type: Boolean, required: true },
    stripeApiKey: { type: String, required: true },
    stripeAccountId: { type: String, required: false, default: null },
  },

  data() {
    const parsedUserInformation = JSON.parse(this.currentUserInformation);

    return {
      userCanInvoice: parsedUserInformation.user_can_invoice,
      noSignUpFlowSelected: true,
      signUpFlowType: 'self',
    };
  },

  methods: {
    updateSignUpFlowType(flowType) {
      this.signUpFlowType = flowType;
      this.noSignUpFlowSelected = false;

      if (flowType === 'self') {
        window.location.href = this.selfSignUpLink;
      }
    },
  },
};
</script>
